// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__DjcOU","image":"Error_image__RVgze","error":"Error_error__pvQbU"};